import React, { useRef, useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import SaveAndSubmit from "../Toolbars/components/SaveAndSubmit";
import AlertMessage from "../AlertMessage";
import {
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Form,
  FormRadio,
  Container,
  Row,
  Col,
} from "shards-react";
import { useRequestHook, useFormHook } from "../../utils/hooks/hooks";
import {
  updateExtractedFields,
  updateWorksteps,
} from "../../utils/redux/actions";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.de";
import EnvelopeDocContainer from "./components/EnvelopeDocContainer";
import ReactivateDocument from "./components/ReactivateDocument";
import SignatureFields from "../Toolbars/components/SignatureFields";
import DragAndDropTabs from "../Toolbars/components/DragAndDropTabs";

const SigantureEnvelopeToolbar = ({
  docId,
  fieldsNames,
  fieldDisplayNames,
  fieldTypes,
  extractedFields,
  dispatch,
  setFieldToBeUpdated,
  approved,
  envelopeName,
  signatureTypeOptionShown,
  sendDocAsOptions,
  signature_type,
  esign_status,
  worksteps,
  reactivationHandler,
  enableSendToTablet,
  userId,
  isNotReactivatable,
  aborted,
  modulesOnFinish,
}) => {
  const formRef = useRef(null);
  const [message, setMessage] = useState(false);
  const [checkAllFields, setCheckAllFields] = useState(null);
  const [sendDocAs, setSendDocAs] = useState(
    sendDocAsOptions && sendDocAsOptions.length > 0
      ? sendDocAsOptions.filter((val) => val === "link")[0]
      : null
  );

  const [envelopeDocuments, updateEnvelopeDocuments] = useState([]);
  const [envelopeNameState, setEnvelopeNameState] = useState(envelopeName);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [signatureType, changeSignatureType] = useState(signature_type);
  const [signatureTypeShown, setSignatureTypeShown] = useState(
    signatureTypeOptionShown
  );
  const [enableSendToTabletOption, setEnableSendToTabletOption] =
    useState(enableSendToTablet);
  const [sendTo, setSendTo] = useState(null);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [doMerge, setDoMerge] = useState(false);

  const { handleRequest } = useRequestHook(); //request to send updated extracted-data in DB
  // cleave.js options
  let formInputClasses = [];
  fieldsNames.map((field, index) => {
    switch (fieldTypes[index] || "text") {
      case "text":
        formInputClasses[field] = {
          delimiter: "",
        };
        break;
      case "number":
        formInputClasses[field] = {
          numeral: true,
          numeralThousandsGroupStyle: "none",
        };
        break;
      case "euro":
        formInputClasses[field] = {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          prefix: "€",
        };
        break;
      case "phone":
        formInputClasses[field] = {
          phone: true,
          phoneRegionCode: "DE",
          prefix: "",
        };
        break;
      default:
        formInputClasses[field] = {};
    }
  });

  const handleWorkstepsChange = (_worksteps) => {
    dispatch(updateWorksteps(_worksteps));
  };

  const handleInputChange = (name, val, displayName, workstep_id) => {
    if (workstep_id !== undefined) {
      const idx = worksteps.findIndex((x) => x.workstep_id === workstep_id);
      const _worksteps = [...worksteps];
      if (idx !== -1) {
        _worksteps[idx][name] = val;
        dispatch(updateWorksteps(_worksteps));
      }
    } else {
      dispatch(
        updateExtractedFields({
          [name]: {
            ...extractedFields[name],
            word: val,
            displayName: displayName,
          },
        })
      );
    }
  };

  const { handleSubmit } = useFormHook(() => {
    if (message) setMessage(false);
    let body = {
      envelope: docId,
      status: true,
      userId,
      data: {
        fields: extractedFields,
        envelopeName: envelopeNameState,
        documents: envelopeDocuments,
        signatureType: signatureType,
        sendDocAs,
      },
    };
    if (worksteps) {
      body["worksteps"] = worksteps;
    }
    if (sendTo) {
      body["send_to"] = sendTo;
    }
    handleRequest("post", "/envelopes/send", body, (response, msg) => {
      if (response) {
        window.location.reload();
      } else {
        let _msg = "Fehler beim Senden des Dokumentes.";

        if (msg) _msg = msg;

        setMessage({
          msg: _msg,
        });
      }
    });
  });

  const submitHandler = () => {
    formRef.current
      .querySelectorAll('#extracted-value[value=""]')
      .forEach((element, index) => {
        if (index === 0)
          setFieldToBeUpdated(
            element.attributes.getNamedItem("data-field").value
          );
      });
    if (worksteps) {
      setCheckAllFields(1);
      return;
    }
    setSendTo(null);
    formRef.current.requestSubmit();
  };

  const compare = (a, b) => {
    if (a.sort > b.sort) {
      return 1;
    } else {
      return -1;
    }
  };

  const updateDocs = (docs, doMerge) => {
    if (docs) {
      docs.sort(compare);
      updateEnvelopeDocuments(docs);
    }

    if (doMerge) {
      setDoMerge(true);
    }

    setUpdateTrigger((oldVal) => oldVal + 1);
  };

  const mergeAndUpdateWorksteps = useCallback(() => {
    if (!worksteps || envelopeDocuments.length === 0) {
      setDoMerge(false);
      return;
    }

    const docsCopy = JSON.parse(JSON.stringify(envelopeDocuments));

    let mergedWorkstepIds = [];
    let updatedWorksteps = [];

    docsCopy.forEach((doc) => {
      doc.worksteps.forEach((docWorkstep) => {
        const foundDocWorkstep = mergedWorkstepIds.find(
          (id) => id === docWorkstep.workstep_id
        );

        if (!foundDocWorkstep) {
          mergedWorkstepIds.push(docWorkstep.workstep_id);
        }
      });

      updatedWorksteps = worksteps.filter((workstep) =>
        mergedWorkstepIds.includes(workstep.workstep_id)
      );
    });

    dispatch(updateWorksteps(updatedWorksteps));

    setDoMerge(false);
  }, [dispatch, envelopeDocuments, fieldsNames, worksteps]);

  useEffect(() => {
    /**
     * Fetch Documents for Envelope from DB.
     */
    handleRequest(
      "post",
      "/envelopes/load-documents",
      { envelopeId: docId },
      (response) => {
        var new_docs = splitWorkstepsElement(response);
        updateDocs(new_docs, false);
      }
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (sendTo !== null) {
      submitHandler();
    }
  }, [sendTo]);

  useEffect(() => {
    if (envelopeDocuments.length > 0) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }

    if (envelopeDocuments.length > 0 && doMerge) mergeAndUpdateWorksteps();
  }, [envelopeDocuments, mergeAndUpdateWorksteps, doMerge]);

  const handleMove = (id, direction) => {
    updateEnvelopeDocuments((oldDocs) => {
      let document_idx;
      let document_swap_idx;
      oldDocs.forEach((doc, idx) => {
        if (doc.docId === id) document_idx = idx;
      });
      let temp_sort = oldDocs[document_idx].sort;
      oldDocs.forEach((doc, idx) => {
        let searchfor =
          oldDocs[document_idx].sort + (direction === "right" ? 1 : -1);
        if (doc.sort === searchfor) document_swap_idx = idx;
      });

      let newDocs = [...oldDocs];
      newDocs[document_idx].sort = oldDocs[document_swap_idx].sort;
      newDocs[document_swap_idx].sort = temp_sort;
      newDocs.sort(compare);
      newDocs = newDocs.map((doc) => {
        doc.signatureCoordinateArray = doc.signatureCoordinateArray.map(
          (coord) => {
            Object.keys(coord).forEach((key) => {
              if (isNaN(Number(key))) {
                coord[key].document_index = doc.sort;
              }
            });
            return coord;
          }
        );

        doc.worksteps = doc.worksteps.map((workstep) => {
          workstep.signature_fields = workstep.signature_fields.map(
            (signField) => {
              signField.document_index = doc.sort;
              return signField;
            }
          );

          return workstep;
        });

        return {
          ...doc,
          signatureCoordinateArray: doc.signatureCoordinateArray.map(
            (coord) => {
              Object.keys(coord).forEach((key) => {
                if (!isNaN(Number(key))) {
                  coord[key].document_index = doc.sort;
                }
              });
              return coord;
            }
          ),
          worksteps: doc.worksteps.map((workstep) => {
            return {
              ...workstep,
              signature_fields: workstep.signature_fields.map((signField) => {
                return {
                  ...signField,
                  document_index: doc.sort,
                };
              }),
            };
          }),
        };
      });

      return newDocs;
    });

    updateDocs(null, true);
  };

  const handleRemove = (docId) => {
    // Update envelope documents
    // UseEffect envelope docuements
    // Handle useEffect
    // Merge signature fields (update worksteps)

    updateEnvelopeDocuments((oldDocs) => {
      const index = oldDocs.findIndex((x) => x.docId === docId);

      let newDocs = [...oldDocs];
      if (index > -1) {
        newDocs.splice(index, 1);

        for (var i = 0; i < newDocs.length; ++i) {
          newDocs[i].sort = i;
        }
      }

      newDocs.sort(compare);

      newDocs = newDocs.map((doc) => {
        doc.signatureCoordinateArray = doc.signatureCoordinateArray.map(
          (coord) => {
            Object.keys(coord).forEach((key) => {
              if (isNaN(Number(key))) {
                coord[key].document_index = doc.sort;
              }
            });
            return coord;
          }
        );

        doc.worksteps = doc.worksteps.map((workstep) => {
          workstep.signature_fields = workstep.signature_fields.map(
            (signField) => {
              signField.document_index = doc.sort;
              return signField;
            }
          );

          return workstep;
        });

        return {
          ...doc,
          signatureCoordinateArray: doc.signatureCoordinateArray.map(
            (coord) => {
              Object.keys(coord).forEach((key) => {
                if (!isNaN(Number(key))) {
                  coord[key].document_index = doc.sort;
                }
              });
              return coord;
            }
          ),
          worksteps: doc.worksteps.map((workstep) => {
            return {
              ...workstep,
              signature_fields: workstep.signature_fields.map((signField) => {
                return {
                  ...signField,
                  document_index: doc.sort,
                };
              }),
            };
          }),
        };
      });

      return newDocs;
    });

    updateDocs(null, true);
  };

  const splitWorkstepsElement = (docs) => {
    let new_docs = docs.slice();
    if (worksteps) {
      return new_docs.map((x, idx) => {
        let _worksteps = [...worksteps]
          .map((y) => {
            let ret = {
              ...y,
              signature_fields: y.signature_fields.filter(
                (z) => z.document_index === idx
              ),
            };
            if (y.formfields) {
              ret = {
                ...ret,
                formfields: y.formfields.filter(
                  (z) => z.document_index === idx
                ),
              };
            }
            return ret;
          })
          .filter(
            (y) =>
              y.signature_fields.length !== 0 ||
              (y.role && y.role.toLowerCase() === "cc")
          );
        x["worksteps"] = _worksteps;
        return x;
      });
    }
    return new_docs;
  };

  return (
    <Form
      innerRef={formRef}
      className="extracted-data envelope-toolbar"
      onSubmit={handleSubmit}
    >
      <InputGroup key="envelope-name" className="col p-0 mb-4">
        <InputGroupAddon type="prepend">
          <InputGroupText className="text-dark">Name der Mappe:</InputGroupText>
        </InputGroupAddon>
        <Cleave
          id="envelope-name"
          className="extbg-white text-right cursor-default form-control"
          placeholder="Bitte Namen eingeben"
          options={{ delimiter: "" }}
          onChange={(e) => setEnvelopeNameState(e.target.value)}
          value={envelopeNameState}
          required
        />
      </InputGroup>
      <Container className="modal-sign-doc-container">
        <Row>
          <Col>
            <div className="d-flex justify-content-center text-uppercase text-light mb-2">
              <strong>Dokumente</strong>
            </div>
            <div style={{ overflowX: "scroll" }} className="pb-4">
              <Container className="modal-sign-card-container">
                <div key="r-1" className="d-flex">
                  <EnvelopeDocContainer
                    docs={envelopeDocuments}
                    move={handleMove}
                    remove={handleRemove}
                    updateTrigger={updateTrigger}
                  />
                </div>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
      {worksteps ? (
        <>
          <DragAndDropTabs
            worksteps={worksteps}
            handleWorkstepsChange={handleWorkstepsChange}
            fieldsNames={fieldsNames}
            isNewEnvelope={true}
            extractedFields={extractedFields}
            fieldDisplayNames={fieldDisplayNames}
            formInputClasses={formInputClasses}
            handleInputChange={handleInputChange}
            checkAllFields={checkAllFields}
            setCheckAllFields={setCheckAllFields}
            setMessage={setMessage}
            formRef={formRef}
            signatureType={signatureType}
            setSendTo={setSendTo}
            modulesOnFinish={modulesOnFinish}
          />
        </>
      ) : (
        <SignatureFields
          fieldsNames={fieldsNames}
          isNewEnvelope={true}
          extractedFields={extractedFields}
          fieldDisplayNames={fieldDisplayNames}
          formInputClasses={formInputClasses}
          handleInputChange={handleInputChange}
          signatureType={signatureType}
        />
      )}
      <div className="mt-2 mb-2">
        <div>
          <p className="mb-2">Unterschrifts-Typ:</p>
          {(signatureTypeShown === "all" ||
            signatureTypeShown === "trusted") && (
            <FormRadio
              inline
              name="trusted"
              checked={signatureType === "trusted"}
              onChange={() => {
                changeSignatureType("trusted");
              }}
            >
              {" "}
              <img
                src="/namirial-logo.png"
                className="icon-trusted"
                alt="icon-trusted"
              />
              Namirial
            </FormRadio>
          )}
          {(signatureTypeShown === "all" ||
            signatureTypeShown === "untrusted") && (
            <FormRadio
              inline
              name="untrusted"
              checked={signatureType === "untrusted"}
              onChange={() => {
                changeSignatureType("untrusted");
              }}
            >
              {" "}
              <img
                src="/logos.png"
                className="icon-untrusted"
                alt="icon-untrusted"
              />
              SYNOP intern
            </FormRadio>
          )}
        </div>
      </div>
      {message && (
        <AlertMessage
          autoDismiss
          alertMessage={message.msg}
          background={message.background}
          setMessage={setMessage}
        />
      )}
      {approved ? (
        esign_status === "signed" || isNotReactivatable || aborted === true ? (
          <></>
        ) : (
          <div className="d-flex justify-content-around">
            <ReactivateDocument reactivationHandler={reactivationHandler} />
          </div>
        )
      ) : (
        isButtonEnabled &&
        (enableSendToTabletOption ? (
          <Row>
            <SaveAndSubmit
              submitText="Per E-Mail versenden"
              submitHandler={() => {
                setSendTo("email");
              }}
              colclass="text-center p-0"
              xs_={6}
              sm_={6}
              md_={6}
              showOnlySubmitColumn={true}
            />
            <SaveAndSubmit
              submitText="An Tablet versenden"
              submitHandler={() => {
                setSendTo("tablet");
              }}
              colclass="text-center p-0"
              xs_={6}
              sm_={6}
              md_={6}
              showOnlySubmitColumn={true}
              submitButtonTheme={"info"}
            />
          </Row>
        ) : (
          <SaveAndSubmit
            submitText="Per E-Mail versenden"
            submitHandler={submitHandler}
            colclass="text-center p-0"
            xs_={12}
            sm_={12}
            md_={12}
          />
        ))
      )}
    </Form>
  );
};

const mapStateToProps = ({
  savedDocument: {
    id: docId,
    extractedFields,
    approved,
    signature_type,
    esign_status,
    worksteps,
    isNotReactivatable,
    aborted,
  },
  userData: { id, services },
}) => {
  /**
   * Take the id, extractedFields and approved value of the document saved in redux and return it
   * in components props.
   */

  const url = window.location.href;
  const parts = url.split("/");
  const service_id = parts[4];
  const idx = services.findIndex(
    (x) => x.serviceType === "signature_envelopes" && x.id === service_id
  );

  const getSignatureTypeSetting = () => {
    let ret = {
      signatureTypeOptionShown: "all",
      signature_type: "trusted",
      enableSendToTablet: false,
    };

    if (services[idx]) {
      const signatureTypeOptionShown = services[idx].signatureTypeOptionShown;
      ret.signatureTypeOptionShown = signatureTypeOptionShown
        ? signatureTypeOptionShown
        : "all";
      if (!approved) {
        const signature_type = services[idx].signatureTypeStandard;
        if (ret.signatureTypeOptionShown === "all") {
          if (signature_type) {
            ret.signature_type = signature_type;
          }
        } else {
          ret.signature_type = signatureTypeOptionShown;
        }
      } else {
        ret.signature_type =
          signature_type === "trusted" ? signature_type : "untrusted";
      }
      const enableSendToTablet = services[idx].enableSendToTablet;
      ret.enableSendToTablet =
        enableSendToTablet !== undefined ? enableSendToTablet : false;
    }

    return ret;
  };

  const getSendDocAsOptions = () => {
    if (idx === -1) return;
    if (!services[idx].notif) return;

    const [notif] = services[idx].notif;

    if (!notif || !notif["-sendDocAs"]) return;

    return notif["-sendDocAs"];
  };

  const sigTypeSetting = getSignatureTypeSetting();
  const sendDocAsOptions = getSendDocAsOptions();

  return {
    docId,
    extractedFields,
    approved,
    signatureTypeOptionShown: sigTypeSetting.signatureTypeOptionShown,
    sendDocAsOptions,
    signature_type: sigTypeSetting.signature_type,
    esign_status,
    worksteps,
    enableSendToTablet: sigTypeSetting.enableSendToTablet,
    userId: id,
    isNotReactivatable,
    aborted,
  };
};

export default connect(mapStateToProps)(SigantureEnvelopeToolbar); //Export component and connect it with redux.
